export default __webpack_public_path__ + "static/media/icon-search.c522d24a.svg";